<template>
  <vue-draggable-resizable
    v-if="!hideParent"
    :parent="true"
    :x="position.left"
    :y="position.top"
    :w="position.width"
    :h="position.height"
    :draggable="!isSavingTemplate && !isWidgetLocked && !isWidgetLockedByOverride"
    :resizable="!isSavingTemplate && !isWidgetLocked && !isWidgetLockedByOverride"
    :grid="gridScale"
    :snap="isSnapActive"
    :active="isWidgetSelected"
    :z="(isWidgetSelected && keepZIndexUp ? 1000 : 100) + widget.position.zIndex"
    :onDragStart="(x, y) => onChangePosition(true, x, y)"
    :onResizeStart="() => onChangePosition(false)"
    @dragstop="onWidgetDrag"
    @resizestop="onWidgetResize"
    @activated="() => onSelected(widget)"
    @deactivated="() => (keepZIndexUp = false)"
    @refLineParams="getRefLineParams"
  >
    <div class="widget-item rss-container" :id="widget.object.wid">
      <RssViewer class="rss-app" :style="{ zoom: scaleTemplateValue(1) }" :setting="rssSetting" />
    </div>
  </vue-draggable-resizable>
</template>

<script>
  import RssViewer from '@/components/rssViewer/RssViewer.vue';
  import VueDraggableResizable from '@/components/common/VueDraggableResizable.vue';
  import draggableWidget from '@/components/templates/mixins/draggableWidget';
  import { simpleTypeMixin } from '@/helpers';

  export default {
    name: 'RssWidget',

    components: {
      VueDraggableResizable,
      RssViewer,
    },

    mixins: [simpleTypeMixin, draggableWidget],

    props: {
      widget: {
        type: Object,
        required: true,
      },
    },

    computed: {
      position() {
        return this.getPosition(this.widget);
      },

      rssSetting() {
        return {
          rssLink: this.widget.object.link,
          rssTheme: this.widget.object.theme,
          rssDuration: this.widget.object.display.duration,
          display: this.widget.object.display,
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .rss-container {
    width: 100%;
    height: 100%;

    .rss-app {
      width: 100%;
      height: 100%;
    }
  }
</style>
